import { useEffect, useRef } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import { selectedTeamIdAtom } from '~teacher/components/Account/atoms/selectedTeamIdAtom';
import { useTeams } from '~teacher/hook/team';

/**
 * After the team list has loaded, select the initial team for the team selector
 */
export function useSelectInitialTeamId() {
  const isMounted = useRef(false); // Only update the initialTeamId once
  const setSelectedTeamId = useSetAtom(selectedTeamIdAtom);
  const currentSelectedTeamId = useAtomValue(selectedTeamIdAtom);

  const teamsQuery = useTeams({
    select: (teams) => {
      // If a team already selected (e.g. from the Account page)
      if (currentSelectedTeamId) return currentSelectedTeamId;

      return teams[0]?.id; // Until we add logic, it selects the first team
    },
  });

  useEffect(() => {
    if (isMounted.current === true || teamsQuery.isLoading) return;

    setSelectedTeamId(teamsQuery.data ?? null); // This is to set it to the correct initial value.

    isMounted.current = true;

    return () => {
      setSelectedTeamId(null);
      isMounted.current = false;
    };
  }, [setSelectedTeamId, teamsQuery.data, teamsQuery.isLoading]);
}
